import postWithToken from './base/post-with-token'

const customerAddNote = (id, data) => postWithToken(`/customer/${id}/timeline/note`)(data)

export default customerAddNote